var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{style:({ background: _vm.bgColor })},[_vm._v(" 版权所有："),_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("粤ICP备18047629号")])])}
var staticRenderFns = []

export { render, staticRenderFns }